import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import useAppStore from 'store/useAppStore';
import IndexField from './IndexField';
import { produce } from 'immer';
import { useShallow } from 'zustand/react/shallow';
import SortableTableRow from './SortableTableRow';
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
const EditStations = () => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const stationKeys = useAppStore((state) => state.stationKeys);
  //const rawStationKeys = useAppStore((state) => state.stationKeys);
  //const normalize = (s) => s.normalize('NFKC').trim();
  //const stationKeys = [...new Set(rawStationKeys.map(normalize))];
  const stationsIds = useAppStore(
    useShallow((state) => state.stations.map(({ id }) => id)),
  );
  const setter = useAppStore((state) => state.setter);
  const reorderStations = useAppStore((state) => state.reorderStations);
  const setStations = (value) => {
    setter('stations', value);
  };
  //const normalizeStations = (stations) =>
  //stations.map((row) => {
  //  const newRow = {};
  //  Object.entries(row).forEach(([k, v]) => {
  //    const nk = normalize(k);
  //    newRow[nk] = v;
  //  });
  //  return newRow;
  //});
  //const setStations = (value) => {
  //  setter('stations', normalizeStations(value));
  //};
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = stationsIds.findIndex((id) => id === active.id);
      const newIndex = stationsIds.findIndex((id) => id === over.id);
      reorderStations(oldIndex, newIndex);
    }
  };
  const getNewItem = () => {
    const initItem = {
      id: uuidv4(),
    };
    stationKeys.forEach((key) => {
      initItem[key] = '';
    });
    return initItem;
  };
  const addStationToPosition = (position) => {
    setStations(
      produce((draft) => {
        draft.splice(position, 0, getNewItem());
      }),
    );
  };
  const addStationToEnd = () => {
    setStations(
      produce((draft) => {
        draft.push(getNewItem());
      }),
    );
  };

  console.log('stationKeys raw:', stationKeys);
  console.log(
    'stationKeys codes:',
    stationKeys.map((k) => ({
      key: k,
      chars: [...k].map((c) => c.charCodeAt(0)),
    })),
  );

  return (
    <>
      <div className="flex justify-between">
        <Typography variant="h6">站台列表</Typography>
        {readOnly === false && (
          <div className="flex gap-2 flex-wrap justify-end">
            <Button
              color="success"
              variant="contained"
              onClick={addStationToEnd}
            >
              新增站台
            </Button>
          </div>
        )}
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <Table>
          <TableHead>
            <TableRow>
              {stationKeys.map((key) => {
                return <TableCell key={key}>{key}</TableCell>;
              })}
              {readOnly === false && (
                <>
                  <TableCell>新增</TableCell>
                  <TableCell>刪除</TableCell>
                  <TableCell sx={{ minWidth: 70 }}>排序</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            <SortableContext
              items={stationsIds}
              strategy={verticalListSortingStrategy}
            >
              {stationsIds.map((id, index) => {
                return (
                  <SortableTableRow id={id} key={id}>
                    {stationKeys.map((key) => {
                      return (
                        <TableCell key={key}>
                          <IndexField
                            type="stations"
                            valueKey={key}
                            placeholder={`輸入${key}內容`}
                            index={index}
                          />
                        </TableCell>
                      );
                    })}
                    {readOnly === false && (
                      <>
                        <TableCell>
                          <IconButton
                            className="self-center"
                            onClick={() => {
                              addStationToPosition(index + 1);
                            }}
                          >
                            <Add color="primary" />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            className="self-center"
                            onClick={() => {
                              setStations(
                                produce((draft) => {
                                  draft.splice(index, 1);
                                }),
                              );
                            }}
                          >
                            <Delete color="error" />
                          </IconButton>
                        </TableCell>
                      </>
                    )}
                  </SortableTableRow>
                );
              })}
            </SortableContext>
          </TableBody>
        </Table>
      </DndContext>
    </>
  );
};
export default EditStations;
